import React, {useMemo} from "react";
import {useSelector} from "react-redux";
import {getRacesData} from "../../../selectors/dictionarySelectors";
import "./_race-component.scss";

function RaceCodeRenderer({raceData}) {
    return (
        <div className="race-component">
            <div style={{background: raceData?.Color}} />
            <span>{raceData?.Code}</span>
        </div>
    );
}

function RaceRenderer({raceData}) {
    return (
        <div className="race-component">
            <div style={{background: raceData?.Color}} />
            <span>
                {raceData?.Code} - {raceData?.Name}
            </span>
        </div>
    );
}

export default function RaceComponent({id, showOnlyCode}) {
    const races = useSelector(getRacesData);

    const raceData = useMemo(() => {
        if (!races) return null;
        return races.find((race) => race.ID === id);
    }, [races, id]);

    if (showOnlyCode) return <RaceCodeRenderer raceData={raceData} />;
    return <RaceRenderer raceData={raceData} />;
}
